import { render } from "./AppBottomPopUp.vue?vue&type=template&id=70040899&scoped=true&ts=true"
import script from "./AppBottomPopUp.vue?vue&type=script&lang=ts"
export * from "./AppBottomPopUp.vue?vue&type=script&lang=ts"

import "./AppBottomPopUp.vue?vue&type=style&index=0&id=70040899&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70040899"]])

export default __exports__